import React, { FC, useState } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import moment from 'moment';

import { DatePickers, PaddedPaper } from 'components';
import { PublicUserProfileFragment, UserFeedFollowGroupFragment } from 'api';
import { UseCheckedState, UseDateRange } from 'types/app';

import { ClearFiltersButton, RangePickerWrapper } from '../shared';
import Filters from './Filters';
import Chips from './Chips';

import { SearchContentFilter } from 'features/admin/types';

interface Props extends Partial<UseDateRange>, Partial<UseCheckedState> {
  filter: SearchContentFilter;
  setFilter: (filter: SearchContentFilter) => void;
  clearFilter: () => void;
  hasFilters: boolean;
}

const FilterBar: FC<Props> = ({ filter, setFilter, hasFilters, clearFilter, ...rest }) => {
  const {
    startDate,
    endDate,
    dateRange,
    setDateRange,
    setStartDate,
    setEndDate,
    ...checkedOptions
  } = rest;

  const [selectedGroups, setSelectedGroups] = useState<UserFeedFollowGroupFragment[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<PublicUserProfileFragment[]>([]);

  let nextStartDate: string = null;
  let nextEndDate: string = null;

  function handleSetStartDate(date: string) {
    nextStartDate = date;
    setStartDate(nextStartDate);
  }

  function handleSetEndDate(date: string) {
    nextEndDate = date;
    setEndDate(nextEndDate);

    setFilter({
      ...filter,
      created_after: moment(nextStartDate).unix(),
      created_before: moment(nextEndDate).add(1, 'days').unix(),
    });
  }

  return (
    <PaddedPaper>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid xs container spacing={2}>
          <Grid>
            <RangePickerWrapper>
              <DatePickers.Range
                dateRange={dateRange}
                startDate={startDate}
                endDate={endDate}
                onSetStart={handleSetStartDate}
                onSetEnd={handleSetEndDate}
                onSetRange={setDateRange}
                includeToday
              />
            </RangePickerWrapper>
          </Grid>
          <Grid>
            <Filters
              filter={filter}
              setFilter={setFilter}
              clearFilter={clearFilter}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              selectedGroups={selectedGroups}
              setSelectedGroups={setSelectedGroups}
              {...checkedOptions}
            />
          </Grid>
        </Grid>

        {hasFilters && (
          <Grid xs container justifyContent="flex-end">
            <ClearFiltersButton onClick={clearFilter} />
          </Grid>
        )}
      </Grid>

      <Grid container>
        <Chips
          filter={filter}
          setFilter={setFilter}
          isEmpty={!hasFilters}
          selectedUsers={selectedUsers}
          selectedGroups={selectedGroups}
        />
      </Grid>
    </PaddedPaper>
  );
};

export default FilterBar;
